<template>
  <div v-if="isDemoSession" class="np-card np-card--info demo-banner" data-test="demo-banner">
    <div class="np-card__icon"><i class="fa fa-flask"></i></div>
    <div class="np-card__content">
      <h4 class="np-card__title">Demo practice · resets nightly</h4>
      <p class="np-card__text">Sample patients and messages. Try anything: nothing is actually sent.</p>
    </div>
    <div class="np-card__actions">
      <b-dropdown
        size="sm"
        variant="outline-secondary"
        right
        :disabled="switching"
        class="demo-banner__view-as"
        data-test="demo-view-as"
      >
        <template #button-content>View as: {{ currentLabel }}</template>
        <b-dropdown-item
          v-for="p in personas"
          :key="p.key"
          :active="!!currentPersona && currentPersona.key === p.key"
          :data-test="'demo-view-as-' + p.key"
          @click="switchTo(p)"
        >{{ p.label }}</b-dropdown-item>
      </b-dropdown>
      <a class="np-card__cta" :href="bookACallUrl" target="_blank" rel="noopener noreferrer" data-test="demo-book-call">Book a call</a>
    </div>
  </div>
</template>

<script>
/**
 * Demo site (Try Teamio, plan Task 6.4): the banner a prospect sees on every page of the demo practice, with the
 * "View as" persona picker and Book a call. Mounted unconditionally in Layout.vue (above NewUiWelcomeBanner) and
 * renders NOTHING unless customer/isDemo is true, the flag read from the sign-in token's claims, so real practices
 * are unaffected. Rules: src/utils/demo/demoShell.js; tests: cypress/node-tests/demo-shell.test.js.
 */
import { BOOK_A_CALL_URL } from '@/utils/demo/demoSession';
import { DEMO_PERSONAS, personaForEmployee, demoErrorMessage } from '@/utils/demo/demoShell';

export default {
  name: 'DemoBanner',

  data() {
    return {
      switching: false,
      personas: DEMO_PERSONAS,
      bookACallUrl: BOOK_A_CALL_URL,
    };
  },

  computed: {
    isDemoSession() {
      return this.$store.getters['customer/isDemo'] === true;
    },
    currentPersona() {
      const c = this.$store.state.customer || {};
      return personaForEmployee(c.userID == null ? null : String(c.userID));
    },
    currentLabel() {
      return this.currentPersona ? this.currentPersona.label : 'Choose a role';
    },
  },

  methods: {
    async switchTo(p) {
      if (this.switching || (this.currentPersona && this.currentPersona.key === p.key)) return;
      this.switching = true;
      try {
        await this.$store.dispatch('customer/demoSwitchRole', { persona: p.key });
      } catch (err) {
        this.$toast.error(demoErrorMessage(err, 'switch'));
      } finally {
        this.switching = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.demo-banner__view-as ::v-deep .btn {
  font-size: 12px;
  padding: 4px 10px;
  background: white;
  white-space: nowrap;
}

.np-card__cta {
  text-decoration: none;

  &:hover, &:focus { color: white; text-decoration: none; }
}

@media (max-width: 768px) {
  .demo-banner__view-as {
    flex: 1;

    ::v-deep .btn { width: 100%; }
  }
}
</style>
